/* eslint-disable */
/* ============================================================
   kevinz.ai — enhancements bundle
   ------------------------------------------------------------
   • StickyNewsletter   — bottom dock that appears past hero
   • CommanderDemo      — sandboxed terminal w/ canned prompts
   • AgentSparkline     — tiny live agent-activity graph
   • CmdK               — operator command palette
   • CareerTimeline     — horizontal 20-yr timeline, dismissible
   ============================================================ */

import React, { useEffect as _useEffectE, useRef as _useRefE, useState as _useStateE, useMemo as _useMemoE } from 'react';
import ReactDOM from 'react-dom';

function injectEnhancementStyles() {
  if (typeof document === "undefined" || document.getElementById("kz-enhancement-styles")) return;
  const style = document.createElement("style");
  style.id = "kz-enhancement-styles";
  style.textContent = `
    .cmd-install{
      display:flex; align-items:center; justify-content:space-between; gap:12px;
      border:1px solid var(--line-strong);
      background:var(--bg-1);
      padding:10px 12px;
      max-width:440px;
      font-family:var(--mono);
      color:var(--fg-2);
    }
    .cmd-install code{ color:var(--fg); font-size:12px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .cmd-install-copy{
      padding:6px 10px !important;
      min-height:0 !important;
      font-size:10px !important;
      letter-spacing:0.12em !important;
      color:var(--fg-3);
      border-color:var(--line) !important;
      flex:none;
    }
    .cmd-install-copy.is-copied{ color:var(--green) !important; border-color:var(--green) !important; }
    .cmd-install-copy.is-failed{ color:var(--red) !important; border-color:var(--red) !important; }
    .cmd-term-title{ min-width:0; }
    .cmd-title-text{ min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
    .cmd-title-fill{ flex:1; min-width:10px; }
    .cmd-spark-wrap{ width:60px; height:16px; display:inline-flex; align-items:center; justify-content:center; flex:none; opacity:0.9; }
    .cmd-sparkline{ width:60px; height:16px; display:block; }
    .cmd-term-line{ white-space:pre; }
    .cmd-term-line.is-ok{ color:var(--green); }
    .cmd-term-line.is-warn{ color:var(--amber); }
    .cmd-term-line.is-cyan{ color:var(--cyan); }
    .cmd-term-line.is-dim{ color:var(--fg-4); }
    .cmdk-entry,
    .cmdk-touch-button{
      display:inline-flex; align-items:center; justify-content:center; gap:8px;
      border:1px solid var(--line-strong);
      background:var(--bg-1);
      color:var(--fg-3);
      font-family:var(--mono);
      font-size:11px;
      letter-spacing:0.16em;
      text-transform:uppercase;
      padding:7px 10px;
      cursor:pointer;
    }
    .cmdk-entry:hover,
    .cmdk-touch-button:hover{ color:var(--amber); border-color:var(--amber); background:color-mix(in oklch, var(--amber) 6%, transparent); }
    .cmdk-touch-button{ display:none; position:fixed; top:44px; right:12px; z-index:58; }
    .cmdk-backdrop{
      position:fixed; inset:0; z-index:120;
      display:flex; align-items:flex-start; justify-content:center;
      padding:12vh 18px 18px;
      background:rgba(0,0,0,0.72);
    }
    .cmdk-panel{
      width:min(540px, 100%);
      border:1px solid var(--line-strong);
      background:var(--bg-1);
      color:var(--fg);
      box-shadow:0 0 0 1px rgba(255,255,255,0.02);
    }
    .cmdk-title{
      display:flex; align-items:center; justify-content:space-between; gap:12px;
      padding:12px 14px;
      border-bottom:1px solid var(--line);
      background:var(--bg-2);
      color:var(--amber);
      font-family:var(--mono);
      font-size:11px;
      letter-spacing:0.18em;
      text-transform:uppercase;
    }
    .cmdk-close{
      border:1px solid var(--line);
      color:var(--fg-3);
      width:28px; height:28px;
      font-size:16px;
      line-height:1;
    }
    .cmdk-close:hover{ color:var(--amber); border-color:var(--amber); }
    .cmdk-input{
      width:100%;
      border:0;
      border-bottom:1px solid var(--line);
      background:var(--bg);
      color:var(--fg);
      font-family:var(--mono);
      font-size:14px;
      padding:14px;
      outline:none;
      border-radius:0;
    }
    .cmdk-input::placeholder{ color:var(--fg-4); }
    .cmdk-list{ max-height:min(420px, 54vh); overflow:auto; padding:6px; }
    .cmdk-row{
      width:100%;
      display:grid;
      grid-template-columns:1fr auto;
      gap:12px;
      text-align:left;
      padding:10px 11px;
      border:1px solid transparent;
      color:var(--fg-2);
      font-family:var(--mono);
    }
    .cmdk-row.is-active,
    .cmdk-row:hover{
      border-color:var(--amber);
      background:color-mix(in oklch, var(--amber) 7%, var(--bg-1));
      color:var(--fg);
    }
    .cmdk-row-title{ font-size:13px; line-height:1.35; }
    .cmdk-row-hint{ color:var(--fg-4); font-size:10px; letter-spacing:0.12em; text-transform:uppercase; margin-top:3px; }
    .cmdk-row-kind{ color:var(--fg-4); font-size:10px; letter-spacing:0.16em; text-transform:uppercase; align-self:center; }
    .cmdk-empty{ padding:24px 14px; color:var(--fg-4); font-family:var(--mono); font-size:12px; }
    .cmdk-live{ position:absolute; width:1px; height:1px; overflow:hidden; clip:rect(0 0 0 0); white-space:nowrap; }
    body[data-konami="1"] .topbar{ border-bottom-color:var(--green); }
    body[data-konami="1"] .sigil{ box-shadow:0 0 18px color-mix(in oklch, var(--green) 55%, transparent); }
    .kz-ee-toast{
      position:fixed; top:16px; left:50%; transform:translateX(-50%);
      z-index:999999;
      border:1px solid var(--cyan, #5FBFB9); background:var(--bg, #000);
      color:var(--cyan, #5FBFB9); font-family:var(--mono, monospace);
      font-size:11px; letter-spacing:0.18em; text-transform:uppercase;
      padding:8px 16px; white-space:nowrap;
      box-shadow:0 0 12px color-mix(in oklch, var(--cyan, #5FBFB9) 35%, transparent);
      pointer-events:none;
      opacity:1; transition:opacity 0.4s ease;
    }
    .kz-ee-toast.is-fading{ opacity:0; }
    @media (hover:none), (pointer:coarse){
      .cmdk-touch-button{ display:inline-flex; }
    }
    @media (max-width:720px){
      .cmd-install{ max-width:none; }
      .cmd-install code{ font-size:11px; }
      .cmdk-backdrop{ align-items:flex-start; padding-top:58px; }
      .cmdk-panel{ width:100%; }
      .cmdk-list{ max-height:62vh; }
      .cmdk-row{ grid-template-columns:1fr; gap:4px; }
      .cmdk-row-kind{ display:none; }
    }
  `;
  document.head.appendChild(style);
}
injectEnhancementStyles();

function useEnhancementMedia(query) {
  const read = () => (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia(query).matches
  );
  const [matches, setMatches] = _useStateE(read);

  _useEffectE(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    if (mql.addEventListener) {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return matches;
}

/* ============================================================
   1. STICKY NEWSLETTER FOOTER
   appears after user scrolls past hero (~600px)
   ============================================================ */
function StickyNewsletter() {
  const [show, setShow] = _useStateE(false);
  const [closed, setClosed] = _useStateE(false);
  const [email, setEmail] = _useStateE("");
  const [done, setDone] = _useStateE(false);
  const [err, setErr] = _useStateE("");
  const [loading, setLoading] = _useStateE(false);
  // Suppress sticky when the in-page Newsletter section is visible
  const [newsInView, setNewsInView] = _useStateE(false);

  _useEffectE(() => {
    const target = document.getElementById("newsletter");
    if (!target || typeof IntersectionObserver === "undefined") return;
    const obs = new IntersectionObserver(
      (entries) => setNewsInView(entries[0].isIntersecting),
      { threshold: 0.1 }
    );
    obs.observe(target);
    return () => obs.disconnect();
  }, []);

  _useEffectE(() => {
    if (closed) return;
    const onScroll = () => {
      const y = window.scrollY;
      const h = window.innerHeight;
      const max = document.documentElement.scrollHeight;
      // show after hero (~80vh) and hide near footer
      const past = y > h * 0.8;
      const nearEnd = y + h > max - 220;
      setShow(past && !nearEnd);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [closed]);

  if (closed) return null;

  return (
    <div className={"sticky-news " + (show && !newsInView ? "is-on" : "")} role="region" aria-label="Subscribe">
      <div className="sn-inner">
        <div className="sn-glyph">▸</div>
        <div className="sn-copy">
          <div className="sn-line">The Agent Report · sundays</div>
          <div className="sn-sub">commit logs from 5 companies. real cost data. no predictions.</div>
          {window.ThinkingBadge && (
            <div style={{ fontSize: 9, letterSpacing: "0.18em", textTransform: "uppercase", marginTop: 6 }}>
              <window.ThinkingBadge />
            </div>
          )}
        </div>
        {!done ? (
          <form className="sn-form" onSubmit={async (e) => {
            e.preventDefault();
            if (!email.includes("@")) return;
            setLoading(true);
            setErr("");
            try {
              const res = await fetch("/api/newsletter-subscribe", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, source: "sticky" }),
              });
              if (res.ok) {
                setDone(true);
                window.plausible?.("email_signup", { props: { audience: "kevinzai", source: "sticky" } });
              } else {
                const data = await res.json().catch(() => ({}));
                setErr(data.error === "invalid_email" ? "invalid email" : "try again");
              }
            } catch (_) {
              setErr("network error");
            } finally {
              setLoading(false);
            }
          }}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@operator.io"
              aria-label="Email"
              disabled={loading}
            />
            <button type="submit" disabled={loading}>{loading ? "..." : "subscribe →"}</button>
          </form>
        ) : (
          <div className="sn-done">✓ confirmed · check your inbox</div>
        )}
        {err && <div style={{ fontSize: 10, color: "var(--red, #f87171)", marginTop: 4 }}>{err}</div>}
        <button className="sn-x" aria-label="Dismiss" onClick={() => setClosed(true)}>×</button>
      </div>
    </div>
  );
}


/* ============================================================
   3. AGENT SPARKLINE — tiny live activity graph for terminal chrome
   ============================================================ */
function AgentSparkline({ width = 60, height = 16 }) {
  const canvasRef = _useRefE(null);
  const pointsRef = _useRefE([]);
  const tickRef = _useRefE(0);
  const reducedMotion = useEnhancementMedia("(prefers-reduced-motion: reduce)");

  _useEffectE(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const total = 24;

    canvas.width = width * dpr;
    canvas.height = height * dpr;
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const seedPoints = () => {
      pointsRef.current = Array.from({ length: total }, (_, i) => {
        const wave = Math.sin((i / total) * Math.PI * 2) * 0.28;
        const jitter = (Math.random() - 0.5) * 0.16;
        return 0.5 + wave + jitter;
      });
    };

    const draw = () => {
      const pts = pointsRef.current;
      ctx.clearRect(0, 0, width, height);
      ctx.strokeStyle = "rgba(95, 191, 185, 0.95)";
      ctx.lineWidth = 1;
      ctx.beginPath();
      pts.forEach((p, i) => {
        const x = (i / (pts.length - 1)) * (width - 2) + 1;
        const y = height - 2 - Math.max(0.08, Math.min(0.92, p)) * (height - 4);
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      });
      ctx.stroke();
    };

    const bump = () => {
      const t = tickRef.current++;
      pointsRef.current = pointsRef.current.slice(1).concat([
        0.5 + Math.sin(t * 0.58) * 0.3 + (Math.random() - 0.5) * 0.24
      ]);
      draw();
    };

    seedPoints();
    draw();
    if (reducedMotion) return;
    const id = setInterval(() => {
      if (!document.hidden) bump();
    }, 800);
    return () => clearInterval(id);
  }, [width, height, reducedMotion]);

  return <canvas ref={canvasRef} className="cmd-sparkline" width={width} height={height} aria-hidden="true" />;
}


/* ============================================================
   4. INTERACTIVE COMMANDER DEMO — typed command + scripted output
   ============================================================ */
const COMMANDER_INSTALL_LINE = "npm install -g cc-commander";
const COMMANDER_RUNS = [
  {
    id: "build",
    label: "Build",
    cmd: "$ ccc-build my-saas-app",
    script: [
      { t: 220, line: "↻ reading ./commander.plan · stack: nextjs + stripe + resend", tone: "dim" },
      { t: 360, line: "model route: planner=claude-sonnet-4.6 · coder=codex-5.3 · reviewer=gpt-5.2", tone: "cyan" },
      { t: 420, line: "cost gate: prefer local cache → free tier → paid escalation", tone: "dim" },
      { t: 420, line: "dispatch[01] architect        → schema + routes + auth boundary" },
      { t: 420, line: "dispatch[02] ui-builder       → dashboard shell + pricing page" },
      { t: 420, line: "dispatch[03] api-builder      → billing webhook + account state" },
      { t: 380, line: "dispatch[04] qa-engineer      → happy path + error path + edge path" },
      { t: 420, line: "dispatch[05] security-review  → secrets, headers, webhook verify" },
      { t: 440, line: "write: 17 files · 4 routes · 6 components · 5 tests", tone: "warn" },
      { t: 460, line: "run: npm test -- --runInBand" },
      { t: 520, line: "✓ tests passed · 12 assertions · 0 snapshots", tone: "ok" },
      { t: 440, line: "handoff: open PR with deployment notes + rollback plan", tone: "ok" }
    ]
  },
  {
    id: "agents",
    label: "Agents",
    cmd: "$ ccc-build my-saas-app --agents 6",
    script: [
      { t: 260, line: "↻ loading agent roster · selecting 6 for this build", tone: "dim" },
      { t: 380, line: "model route: scout=fast · architect=deep · qa=deterministic", tone: "cyan" },
      { t: 420, line: "agent/scout        → dependency map + existing patterns" },
      { t: 420, line: "agent/architect    → app boundary + data model" },
      { t: 420, line: "agent/builder-a    → onboarding + account screens" },
      { t: 420, line: "agent/builder-b    → api handlers + billing events" },
      { t: 420, line: "agent/reviewer     → risk list + patch notes" },
      { t: 420, line: "agent/qa           → browser smoke + unit coverage" },
      { t: 460, line: "sync: 6 branches folded into one patch queue", tone: "warn" },
      { t: 500, line: "conflicts: 0 · unresolved questions: 2 · blockers: 0" },
      { t: 520, line: "✓ fleet idle · summary written to .commander/runs/saas-app.md", tone: "ok" }
    ]
  },
  {
    id: "verify",
    label: "Verify",
    cmd: "$ ccc-build my-saas-app --verify",
    script: [
      { t: 240, line: "↻ replaying run manifest · 17 files changed", tone: "dim" },
      { t: 380, line: "model route: reviewer=gpt-5.2 · security=claude-sonnet-4.6", tone: "cyan" },
      { t: 420, line: "check/typescript    → strict mode · no implicit any" },
      { t: 420, line: "check/zod           → runtime validation at api edge" },
      { t: 420, line: "check/secrets       → no tokens, no plaintext env writes" },
      { t: 420, line: "check/mobile        → 320px, 375px, 768px, 1440px" },
      { t: 460, line: "check/a11y          → labels, focus order, escape paths" },
      { t: 520, line: "run: npm run lint && npm test && npm run build" },
      { t: 520, line: "✓ lint clean · tests green · build complete", tone: "ok" },
      { t: 440, line: "risk: stripe test clock requires manual smoke before launch", tone: "warn" }
    ]
  },
  {
    id: "ship",
    label: "Ship",
    cmd: "$ ccc-build my-saas-app --ship",
    script: [
      { t: 260, line: "↻ packaging deployment bundle · target: vercel", tone: "dim" },
      { t: 380, line: "model route: release-manager=claude-sonnet-4.6", tone: "cyan" },
      { t: 420, line: "preflight: env vars mapped · webhooks pinned · logs enabled" },
      { t: 420, line: "deploy preview: my-saas-app-git-main.vercel.app", tone: "warn" },
      { t: 460, line: "smoke[01] signup → pass" },
      { t: 460, line: "smoke[02] checkout → pass" },
      { t: 460, line: "smoke[03] webhook replay → pass" },
      { t: 500, line: "release notes: generated · rollback: previous build retained" },
      { t: 540, line: "✓ shipped · preview ready · production gate waiting", tone: "ok" }
    ]
  }
];

function copyEnhancementText(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.left = "-9999px";
  document.body.appendChild(ta);
  ta.select();
  const ok = document.execCommand("copy");
  document.body.removeChild(ta);
  return ok ? Promise.resolve() : Promise.reject(new Error("copy failed"));
}

function CommanderDemo() {
  const reducedMotion = useEnhancementMedia("(prefers-reduced-motion: reduce)");
  const [running, setRunning] = _useStateE(false);
  const [activeIndex, setActiveIndex] = _useStateE(0);
  const [typedCommand, setTypedCommand] = _useStateE("");
  const [lines, setLines] = _useStateE([]);
  const [copyState, setCopyState] = _useStateE("idle");
  const timersRef = _useRefE([]);
  const copyTimerRef = _useRefE(0);
  const sectionRef = _useRefE(null);
  const startedRef = _useRefE(false);
  const hiddenRef = _useRefE(typeof document !== "undefined" ? document.hidden : false);
  const reducedRef = _useRefE(false);
  const activeIndexRef = _useRefE(0);

  const clearTimers = () => {
    timersRef.current.forEach(clearTimeout);
    timersRef.current = [];
  };

  const renderStatic = (index) => {
    const run = COMMANDER_RUNS[index % COMMANDER_RUNS.length];
    activeIndexRef.current = index % COMMANDER_RUNS.length;
    setActiveIndex(activeIndexRef.current);
    setTypedCommand(run.cmd);
    setLines(run.script.map((step) => ({ text: step.line, tone: step.tone || "" })));
    setRunning(false);
  };

  const runDemo = (index) => {
    clearTimers();
    const safeIndex = index % COMMANDER_RUNS.length;
    const run = COMMANDER_RUNS[safeIndex];
    activeIndexRef.current = safeIndex;
    setActiveIndex(safeIndex);

    if (reducedRef.current) {
      renderStatic(safeIndex);
      return;
    }

    if (hiddenRef.current) {
      setRunning(false);
      return;
    }

    setTypedCommand("");
    setLines([]);
    setRunning(true);

    const chars = run.cmd.split("");
    chars.forEach((_, i) => {
      const tid = setTimeout(() => {
        setTypedCommand(run.cmd.slice(0, i + 1));
      }, i * 24);
      timersRef.current.push(tid);
    });

    let acc = chars.length * 24 + 220;
    run.script.forEach((step, i) => {
      acc += step.t;
      const tid = setTimeout(() => {
        setLines((prev) => [...prev, { text: step.line, tone: step.tone || "" }]);
        if (i === run.script.length - 1) {
          const done = setTimeout(() => {
            setRunning(false);
            const next = setTimeout(() => runDemo((safeIndex + 1) % COMMANDER_RUNS.length), 4000);
            timersRef.current.push(next);
          }, 260);
          timersRef.current.push(done);
        }
      }, acc);
      timersRef.current.push(tid);
    });
  };

  const handleCopyInstall = async () => {
    clearTimeout(copyTimerRef.current);
    try {
      await copyEnhancementText(COMMANDER_INSTALL_LINE);
      setCopyState("copied");
    } catch (_) {
      setCopyState("failed");
    }
    copyTimerRef.current = setTimeout(() => setCopyState("idle"), 1500);
  };

  _useEffectE(() => {
    reducedRef.current = reducedMotion;
    if (reducedMotion && startedRef.current) {
      clearTimers();
      renderStatic(activeIndexRef.current);
    }
  }, [reducedMotion]);

  _useEffectE(() => {
    const onVisibility = () => {
      hiddenRef.current = document.hidden;
      if (document.hidden) {
        clearTimers();
        setRunning(false);
        return;
      }
      if (startedRef.current && !reducedRef.current) {
        const tid = setTimeout(() => runDemo(activeIndexRef.current), 500);
        timersRef.current.push(tid);
      }
    };
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, []);

  _useEffectE(() => () => {
    clearTimers();
    clearTimeout(copyTimerRef.current);
  }, []);

  _useEffectE(() => {
    if (!sectionRef.current || startedRef.current) return;
    const obs = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && !startedRef.current) {
          startedRef.current = true;
          runDemo(0);
          obs.disconnect();
          break;
        }
      }
    }, { threshold: 0.25 });
    obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  const commandBody = typedCommand.replace(/^\$ ?/, "");
  const copyLabel = copyState === "copied" ? "✓ copied" : copyState === "failed" ? "copy failed" : "▸ copy";

  return (
    <section ref={sectionRef} id="demo" data-section="commander" className="section-pad">
      <div className="container">
        <div className="box-head">
          <window.AsciiBadge glyph="block" count={3} />
          <span>// 03b — watch it run · live sandbox</span>
          <span className="rule" />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1.4fr", gap: 28, alignItems: "start" }} className="demo-grid">
          <div>
            <h2 className="h-section">all the best skills. one install.</h2>
            <p className="lede mt-20" style={{ maxWidth: "44ch" }}>
              Watch Commander route models, dispatch agents, run checks, and hand back a shippable patch.
            </p>

            <div className="cmd-install mt-20">
              <code>{COMMANDER_INSTALL_LINE}</code>
              <button
                type="button"
                className={"btn btn-ghost cmd-install-copy " + (copyState === "copied" ? "is-copied" : copyState === "failed" ? "is-failed" : "")}
                onClick={handleCopyInstall}
                aria-label="Copy Commander install command">
                {copyLabel}
              </button>
            </div>

            <div className="demo-prompts mt-24">
              {COMMANDER_RUNS.map((p, idx) => (
                <button
                  key={p.id}
                  className={"demo-pill " + (activeIndex === idx ? "is-on" : "")}
                  onClick={() => runDemo(idx)}>
                  <span className="demo-pill-num">[{String(idx + 1).padStart(2, "0")}]</span>
                  <span>{p.label}</span>
                  <span className="demo-pill-arrow">↗</span>
                </button>
              ))}
            </div>
            <div className="dim mt-24" style={{ fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase" }}>
              ▸ install the real one · <a href="https://commanderplugin.com" target="_blank" rel="noreferrer" className="amber">commanderplugin.com</a>
            </div>
          </div>

          <div className="terminal" style={{ minHeight: 380 }}>
            <div className="win-title cmd-term-title">
              <div className="lights"><span className="r" /><span className="a" /><span className="g" /></div>
              <span className="cmd-title-text">~/sandbox · commander · {document.hidden ? "paused" : running ? "running" : "ready"}</span>
              <span className="cmd-title-fill" />
              <span className="cmd-spark-wrap"><window.AgentSparkline /></span>
              <span className="meta">{lines.length + (typedCommand ? 1 : 0)} lines</span>
            </div>
            <div className="body" style={{ minHeight: 320 }}>
              {!typedCommand && lines.length === 0 && (
                <div className="dim" style={{ fontSize: 12.5 }}>
                  $ ccc-build my-saas-app<span className="cursor" />
                </div>
              )}
              {(typedCommand || lines.length > 0) && (
                <div className="cmd-term-line">
                  <span className="term-prompt">$</span>{commandBody ? " " + commandBody : ""}
                  {running && lines.length === 0 && <span className="cursor" />}
                </div>
              )}
              {lines.map((l, i) => (
                <div key={i} className={"cmd-term-line " + (l.tone ? "is-" + l.tone : "")} style={{ paddingLeft: 4 }}>{l.text}</div>
              ))}
              {running && lines.length > 0 && <div><span className="term-amber">▌</span> <span className="dim">working</span><span className="cursor" /></div>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}


/* ============================================================
   5. CMD-K PALETTE — operator navigation modal
   ============================================================ */
const CMDK_OPEN_EVENT = "kz:cmdk-open";
const CMDK_CLOSE_EVENT = "kz:cmdk-close";
const CMDK_POSTS = [
  "how-i-know-36-agents-are-alive",
  "cost-optimized-llm-routing",
  "agent-fleet-architecture",
  "multi-agent-systems-beginners",
  "write-better-ai-prompts",
  "the-daily-claude-code-loop",
  "running-200-free-models",
  "from-one-agent-to-a-fleet"
];

function cmdkRequestOpen() {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(CMDK_OPEN_EVENT));
}

function cmdkRequestClose() {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(CMDK_CLOSE_EVENT));
}

function cmdkIsTextField(node) {
  if (!node) return false;
  const tag = node.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || node.isContentEditable;
}

function cmdkScrollTo(section) {
  const selector = section === "hero" ? '[data-section="hero"]' : `#${section}, [data-section="${section}"]`;
  const el = document.querySelector(selector);
  if (el) {
    const reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    el.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
    return;
  }
  window.location.href = section === "hero" ? "/" : "/#" + section;
}

function cmdkFuzzyScore(source, query) {
  const q = query.toLowerCase().replace(/\s+/g, "");
  if (!q) return 1;
  const text = source.toLowerCase();
  let qi = 0;
  let score = 0;
  let streak = 0;
  for (let i = 0; i < text.length && qi < q.length; i++) {
    if (text[i] === q[qi]) {
      qi++;
      streak++;
      score += 6 + streak * 2;
      if (i === 0 || text[i - 1] === ":" || text[i - 1] === " " || text[i - 1] === "/") score += 4;
    } else {
      streak = 0;
    }
  }
  return qi === q.length ? score - text.length * 0.02 : -1;
}

function cmdkCommands() {
  return [
    { id: "goto-hero", title: "goto: hero", hint: "top of kevinz.ai", kind: "nav", run: () => cmdkScrollTo("hero") },
    { id: "goto-writing", title: "goto: writing", hint: "operator essays", kind: "nav", run: () => cmdkScrollTo("writing") },
    { id: "goto-commander", title: "goto: commander", hint: "cli + agent demo", kind: "nav", run: () => cmdkScrollTo("commander") },
    { id: "goto-projects", title: "goto: projects", hint: "5 product brands", kind: "nav", run: () => cmdkScrollTo("projects") },
    { id: "goto-about", title: "goto: about", hint: "/about", kind: "nav", run: () => { window.location.href = "/about"; } },
    { id: "goto-uses", title: "goto: uses", hint: "/uses", kind: "nav", run: () => { window.location.href = "/uses"; } },
    { id: "goto-now", title: "goto: now", hint: "/now", kind: "nav", run: () => { window.location.href = "/now"; } },
    { id: "goto-contact", title: "goto: contact", hint: "send a ping", kind: "nav", run: () => cmdkScrollTo("contact") },
    { id: "theme-invert", title: "theme: invert", hint: "toggle data-theme", kind: "action", run: () => {
      const cur = document.body.dataset.theme || "auto";
      document.body.dataset.theme = cur === "cyan" ? "auto" : "cyan";
    } },
    { id: "try-ascii", title: "try: ascii-tool", hint: "portrait lab", kind: "action", run: () => { window.location.href = "/?view=ascii"; } },
    { id: "subscribe-newsletter", title: "subscribe: newsletter", hint: "The Agent Report", kind: "action", run: () => {
      cmdkScrollTo("newsletter");
      setTimeout(() => {
        const input = document.querySelector('#newsletter input[type="email"]');
        if (input && input.focus) input.focus();
      }, 420);
    } },
    { id: "mailto", title: "mailto: hi@kevinz.ai", hint: "open email client", kind: "action", run: () => { window.location.href = "mailto:hi@kevinz.ai"; } },
    { id: "easter-konami", title: "easter: konami", hint: "flash the operator rail", kind: "action", run: () => {
      document.body.dataset.konami = "1";
      window.dispatchEvent(new CustomEvent("kz:konami"));
      setTimeout(() => { delete document.body.dataset.konami; }, 1800);
    } },
    { id: "random-post", title: "random: post", hint: "open one essay", kind: "nav", run: () => {
      const slug = CMDK_POSTS[Math.floor(Math.random() * CMDK_POSTS.length)];
      window.location.href = "/post/" + slug;
    } }
  ];
}

function CmdK({ entry = true, listen = false, touchButton = false }) {
  const isTouch = useEnhancementMedia("(hover: none), (pointer: coarse)");
  const [open, setOpen] = _useStateE(false);
  const [query, setQuery] = _useStateE("");
  const [activeIndex, setActiveIndex] = _useStateE(0);
  const inputRef = _useRefE(null);
  const dialogRef = _useRefE(null);
  const lastFocusRef = _useRefE(null);
  const commands = _useMemoE(() => cmdkCommands(), []);
  const filtered = _useMemoE(() => {
    const q = query.trim();
    return commands
      .map((cmd, order) => ({
        cmd,
        order,
        score: cmdkFuzzyScore(`${cmd.title} ${cmd.hint} ${cmd.kind}`, q)
      }))
      .filter((row) => row.score >= 0)
      .sort((a, b) => (b.score - a.score) || (a.order - b.order))
      .map((row) => row.cmd);
  }, [commands, query]);

  const openPalette = () => {
    lastFocusRef.current = document.activeElement;
    setQuery("");
    setActiveIndex(0);
    setOpen(true);
  };

  const closePalette = () => setOpen(false);

  const execute = (cmd) => {
    if (!cmd) return;
    try {
      cmd.run();
    } finally {
      closePalette();
    }
  };

  _useEffectE(() => {
    if (activeIndex >= filtered.length) setActiveIndex(0);
  }, [activeIndex, filtered.length]);

  _useEffectE(() => {
    if (!listen) return;
    const onOpen = () => openPalette();
    const onClose = () => closePalette();
    window.addEventListener(CMDK_OPEN_EVENT, onOpen);
    window.addEventListener(CMDK_CLOSE_EVENT, onClose);
    return () => {
      window.removeEventListener(CMDK_OPEN_EVENT, onOpen);
      window.removeEventListener(CMDK_CLOSE_EVENT, onClose);
    };
  }, [listen]);

  _useEffectE(() => {
    if (!listen) return;
    const onKey = (e) => {
      if (!((e.metaKey || e.ctrlKey) && String(e.key).toLowerCase() === "k")) return;
      if (isTouch) return;
      const target = e.target;
      const inPalette = target && target.closest && target.closest(".cmdk-panel");
      if (cmdkIsTextField(target) && !inPalette) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (open) closePalette();
      else openPalette();
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [listen, isTouch, open]);

  _useEffectE(() => {
    if (!listen) return;
    if (!open) {
      const node = lastFocusRef.current;
      if (node && node.focus) setTimeout(() => node.focus(), 0);
      return;
    }
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const id = setTimeout(() => {
      if (inputRef.current) inputRef.current.focus();
    }, 0);
    return () => {
      clearTimeout(id);
      document.body.style.overflow = previousOverflow;
    };
  }, [listen, open]);

  const handleDialogKeyDown = (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      closePalette();
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((i) => filtered.length ? (i + 1) % filtered.length : 0);
      return;
    }
    if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((i) => filtered.length ? (i - 1 + filtered.length) % filtered.length : 0);
      return;
    }
    if (e.key === "Enter" && !e.isComposing) {
      e.preventDefault();
      execute(filtered[activeIndex]);
      return;
    }
    if (e.key === "Tab" && dialogRef.current) {
      const focusable = Array.from(dialogRef.current.querySelectorAll('button, input, [href], [tabindex]:not([tabindex="-1"])'))
        .filter((el) => !el.disabled && el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };

  const entryButton = entry ? (
    <button type="button" className="cmdk-entry" onClick={cmdkRequestOpen} aria-label="Open command palette">
      $ cmd
    </button>
  ) : null;

  if (!listen) return entryButton;

  const touchEntry = touchButton && isTouch && !open ? (
    <button type="button" className="cmdk-touch-button" onClick={openPalette} aria-label="Open command palette">
      $ cmd
    </button>
  ) : null;

  const modal = open ? (
    <div className="cmdk-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) closePalette(); }}>
      <div
        ref={dialogRef}
        className="cmdk-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cmdk-title"
        onKeyDown={handleDialogKeyDown}>
        <div className="cmdk-title">
          <span id="cmdk-title">// command palette</span>
          <button type="button" className="cmdk-close" onClick={closePalette} aria-label="Close command palette">×</button>
        </div>
        <input
          ref={inputRef}
          className="cmdk-input"
          value={query}
          onChange={(e) => { setQuery(e.target.value); setActiveIndex(0); }}
          placeholder="filter commands"
          aria-label="Filter commands"
          aria-controls="cmdk-list"
          aria-activedescendant={filtered[activeIndex] ? "cmdk-option-" + filtered[activeIndex].id : undefined}
        />
        <div className="cmdk-live" aria-live="polite">{filtered.length} commands</div>
        <div id="cmdk-list" className="cmdk-list" role="listbox" aria-label="Commands">
          {filtered.length === 0 ? (
            <div className="cmdk-empty">no command found</div>
          ) : filtered.map((cmd, idx) => (
            <button
              type="button"
              key={cmd.id}
              id={"cmdk-option-" + cmd.id}
              className={"cmdk-row " + (idx === activeIndex ? "is-active" : "")}
              role="option"
              aria-selected={idx === activeIndex}
              onMouseEnter={() => setActiveIndex(idx)}
              onClick={() => execute(cmd)}>
              <span>
                <span className="cmdk-row-title">{cmd.title}</span>
                <span className="cmdk-row-hint">{cmd.hint}</span>
              </span>
              <span className="cmdk-row-kind">{cmd.kind}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  ) : null;

  return (
    <>
      {entryButton}
      {touchEntry}
      {modal && ReactDOM.createPortal ? ReactDOM.createPortal(modal, document.body) : modal}
    </>
  );
}
CmdK.open = cmdkRequestOpen;
CmdK.close = cmdkRequestClose;

function mountCmdKSingleton() {
  if (typeof document === "undefined" || window.__kzCmdKMounted) return;
  const mount = () => {
    if (window.__kzCmdKMounted || document.getElementById("kz-cmdk-root")) return;
    window.__kzCmdKMounted = true;
    const root = document.createElement("div");
    root.id = "kz-cmdk-root";
    document.body.appendChild(root);
    if (ReactDOM.createRoot) {
      ReactDOM.createRoot(root).render(<CmdK entry={false} listen={true} touchButton={true} />);
    } else {
      ReactDOM.render(<CmdK entry={false} listen={true} touchButton={true} />, root);
    }
  };
  if (document.body) mount();
  else document.addEventListener("DOMContentLoaded", mount, { once: true });
}
mountCmdKSingleton();


/* ============================================================
   6. CAREER TIMELINE — horizontal 20-yr arc · dismissible

   STATUS (2026-04-25): ARCHIVED but preserved.
   Currently unmounted in app.jsx. Per Kevin: keep in source for a
   possible future remount or migration to a /career or /timeline
   route. Do NOT delete — it captures real career data that's hard
   to re-derive. To remount: add <window.CareerTimeline /> to app.jsx
   between <Credentials /> and <window.AsciiPicCTA />.
   ============================================================ */
function CareerTimeline() {
  const [closed, setClosed] = _useStateE(false);

  // Best-guess composite based on the rest of the site copy.
  // User can edit, dismiss, or keep.
  const events = [
    { y: "2005", t: "First exit", d: "Sold first venture in early-stage mobile.", tag: "founder" },
    { y: "2010", t: "MyWiFi Networks", d: "Hospitality WiFi marketing → 40+ countries.", tag: "founder" },
    { y: "2014", t: "Best-seller", d: "Amazon best-selling author · mobile marketing.", tag: "author" },
    { y: "2017", t: "Udemy · 5K+ students", d: "WiFi marketing curriculum.", tag: "teacher" },
    { y: "2019", t: "Collision Stage", d: "Keynote on captive-portal economics.", tag: "speaker" },
    { y: "2022", t: "Guest Networks", d: "Physical-space data plane spinout.", tag: "founder" },
    { y: "2023", t: "DMHub", d: "WhatsApp-first AI front desk.", tag: "founder" },
    { y: "2024", t: "ReadyIQ", d: "AI deployment for non-technical CEOs.", tag: "founder" },
    { y: "2025", t: "OpenClaw + Hermes", d: "Self-hosted agent workforce.", tag: "operator" },
    { y: "2026", t: "Commander · AI agent teams", d: "OSS AI command layer · 70 plugin skills.", tag: "operator" }
  ];

  if (closed) return null;

  return (
    <section data-section="timeline" className="section-pad" style={{ paddingTop: 40, paddingBottom: 40 }}>
      <div className="container">
        <div className="box-head">
          <window.AsciiBadge glyph="bracket" count={3} />
          <span>// 1.5 — twenty years · one continuous arc</span>
          <span className="rule" />
          <button
            onClick={() => setClosed(true)}
            style={{
              fontFamily: "var(--mono)", fontSize: 10, letterSpacing: "0.18em",
              textTransform: "uppercase", color: "var(--fg-4)", background: "transparent",
              border: "1px solid var(--line)", padding: "4px 10px", cursor: "pointer"
            }}
            title="Dismiss timeline">
            × dismiss
          </button>
        </div>

        <div className="timeline-wrap">
          <div className="timeline-axis" />
          <div className="timeline-track">
            {events.map((e, i) => (
              <div key={i} className={"tl-item " + (i % 2 ? "tl-down" : "tl-up")}>
                <div className="tl-stem" />
                <div className="tl-card">
                  <div className="tl-year">{e.y}</div>
                  <div className="tl-title">{e.t}</div>
                  <div className="tl-desc">{e.d}</div>
                  <div className="tl-tag">[ {e.tag} ]</div>
                </div>
                <div className="tl-dot" />
              </div>
            ))}
          </div>
        </div>
        <div className="dim mt-12" style={{ fontSize: 10, letterSpacing: "0.2em", textTransform: "uppercase", textAlign: "center" }}>
          scroll horizontally · ←→
        </div>
      </div>
    </section>
  );
}
/* ============================================================
   7. EASTER EGGS
   EE-01: Konami Code (↑↑↓↓←→←→BA) → VHS Mode (30s)
   EE-02: Type "kevin" → .ascii-face / .biz-face spin
   ============================================================ */
function setupEasterEggs() {
  if (typeof window === "undefined" || window.__kzEasterEggsInit) return;
  window.__kzEasterEggsInit = true;

  const reducedMotion = () =>
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const isTextField = (node) => {
    if (!node) return false;
    const tag = node.tagName;
    return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || node.isContentEditable;
  };

  // --- Toast helper ---
  function showToast(msg) {
    const existing = document.getElementById("kz-ee-toast");
    if (existing) existing.remove();
    const el = document.createElement("div");
    el.id = "kz-ee-toast";
    el.className = "kz-ee-toast";
    el.textContent = msg;
    document.body.appendChild(el);
    const fadeTimer = setTimeout(() => el.classList.add("is-fading"), 2700);
    const removeTimer = setTimeout(() => el.remove(), 3200);
    el._timers = [fadeTimer, removeTimer];
  }

  // --- EE-01: Konami Code → VHS Mode ---
  const KONAMI = [
    "ArrowUp", "ArrowUp", "ArrowDown", "ArrowDown",
    "ArrowLeft", "ArrowRight", "ArrowLeft", "ArrowRight",
    "b", "a"
  ];
  const konamiBuffer = [];
  let vhsTimer = null;

  function activateVHS() {
    if (reducedMotion()) return;
    document.body.classList.add("vhs-mode");
    showToast("VHS_MODE_ENABLED · 0:30 remaining.");
    clearTimeout(vhsTimer);
    vhsTimer = setTimeout(() => {
      document.body.classList.remove("vhs-mode");
    }, 30000);
  }

  // --- EE-02: Type "kevin" → face spin ---
  const KEVIN_SEQ = ["k", "e", "v", "i", "n"];
  const kevinBuffer = [];
  const KEVIN_COOLDOWN_MS = 24 * 60 * 60 * 1000; // 24 hours

  function canTriggerKevin() {
    try {
      const ts = localStorage.getItem("kz_kevin_egg");
      if (!ts) return true;
      return Date.now() - parseInt(ts, 10) > KEVIN_COOLDOWN_MS;
    } catch (_) {
      return true;
    }
  }

  function activateKevinSpin() {
    if (reducedMotion()) return;
    const face = document.querySelector(".ascii-face") || document.querySelector(".biz-face");
    if (!face) return;
    try { localStorage.setItem("kz_kevin_egg", String(Date.now())); } catch (_) {}
    face.style.transition = "transform 1s cubic-bezier(0.4, 0, 0.2, 1)";
    face.style.transform = "rotateY(360deg)";
    setTimeout(() => {
      face.style.transform = "";
      setTimeout(() => { face.style.transition = ""; }, 50);
    }, 1050);
  }

  // --- Shared keydown listener ---
  window.addEventListener("keydown", (e) => {
    if (isTextField(document.activeElement)) return;

    const key = e.key;

    // Konami buffer (10-key, case-sensitive for arrow keys, lowercase for BA)
    konamiBuffer.push(key);
    if (konamiBuffer.length > KONAMI.length) konamiBuffer.shift();
    if (konamiBuffer.join(",") === KONAMI.join(",")) {
      konamiBuffer.length = 0;
      activateVHS();
    }

    // Kevin buffer (5-key, lowercase letters only)
    if (key.length === 1) {
      kevinBuffer.push(key.toLowerCase());
      if (kevinBuffer.length > KEVIN_SEQ.length) kevinBuffer.shift();
      if (kevinBuffer.join("") === KEVIN_SEQ.join("") && canTriggerKevin()) {
        kevinBuffer.length = 0;
        activateKevinSpin();
      }
    }
  });
}
setupEasterEggs();


Object.assign(window, {
  StickyNewsletter,
  AgentSparkline,
  CommanderDemo,
  CmdK,
  CareerTimeline
});

export {
  StickyNewsletter,
  AgentSparkline,
  CommanderDemo,
  CmdK,
  CareerTimeline
};
